// All Hours Logo - House with Checkmark
export const AllHoursLogo = ({ size = 64, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* House outline */}
      <path
        d="M50 10L10 45V90H40V65H60V90H90V45L50 10Z"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Checkmark */}
      <path
        d="M30 52L45 67L75 32"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// Smaller icon version for headers/navs
export const AllHoursIcon = ({ size = 40, className = "" }) => {
  return (
    <div 
      className={`flex items-center justify-center rounded-xl bg-slate-900 text-white ${className}`}
      style={{ width: size, height: size }}
    >
      <svg
        width={size * 0.6}
        height={size * 0.6}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* House outline */}
        <path
          d="M50 10L10 45V90H40V65H60V90H90V45L50 10Z"
          stroke="currentColor"
          strokeWidth="7"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        {/* Checkmark */}
        <path
          d="M30 52L45 67L75 32"
          stroke="currentColor"
          strokeWidth="9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default AllHoursLogo;
